export default "__VITE_ASSET__CIk9D2Aj__"